import React, { useRef } from "react";
import {
  TextField,
  InputAdornment,
  IconButton,
  Popper,
  Paper
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import dayjs from "dayjs";
import CustomDateRangePicker from "../../../../../components/CustomDateRangePicker";

export default function DateRangeField({
  fieldKey,
  label,
  value,
  onChange,
  openField,
  setOpenField,
  disabled
}) {
  const anchorRef = useRef(null);
  const open = openField === fieldKey;

  const displayValue =
    value?.fromDate && value?.toDate
      ? `${dayjs(value.fromDate).format("MM-DD-YYYY")} - ${dayjs(
          value.toDate
        ).format("MM-DD-YYYY")}`
      : "";

  return (
    <>
      <TextField
        ref={anchorRef}
        sx={{ mb: 1.5 }}
        label={label}
        size="small"
        fullWidth
        value={displayValue}
        disabled={disabled}
        onClick={() => !disabled && setOpenField(fieldKey)}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onChange(null);
                }}
              >
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        sx={{ zIndex: 1500 }}
      >
        <Paper elevation={6}>
          <CustomDateRangePicker
            indexValue={0}
            defaultDateRangeValue={value || ""}
            onDateSelect={(index, range) => {
              if (!range?.[0] || !range?.[1]) {
                onChange(null);
                setOpenField(null);
                return;
              }

              onChange({
                fromDate: range[0].format("YYYY-MM-DD"),
                toDate: range[1].format("YYYY-MM-DD")
              });
              setOpenField(null);
            }}
            handleCloseDatePicker={() => setOpenField(null)}
          />
        </Paper>
      </Popper>
    </>
  );
}

